import React from "react";
import { Link } from "react-router-dom";
import { homePageV2About } from "../content/homePageV2Content";

export function AboutSectionV2() {
  const { founder, paragraphs, regions } = homePageV2About;

  return (
    <section className="mh2v2-about mh2v2-section-charcoal">
      <div className="mh2v2-container">
        <div className="mh2v2-about-grid">
          <div className="mh2v2-about-founder">
            <img src={founder.image} alt={founder.name} />
            <div className="mh2v2-about-founder__caption">
              <h4>{founder.name}</h4>
              <p>{founder.role}</p>
            </div>

            <div className="mh2v2-region-row mh2v2-region-row--compact">
              {regions.map((region) => (
                <Link
                  key={region.label}
                  to={region.to}
                  className="mh2v2-pill mh2v2-pill--region teal"
                >
                  {region.label} →
                </Link>
              ))}
            </div>
          </div>

          <div className="mh2v2-about-copy">
            <h3 className="mh2v2-section-title mh2v2-section-title--light">
              ABOUT THE MAMAHOOD
            </h3>
            {/* TODO: founder bio CMS */}
            {paragraphs.map((paragraph) => (
              <p key={paragraph.slice(0, 48)}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSectionV2;
